import React, { Component, useRef, useEffect } from "react";
import styled from "styled-components";
import { DialogContent } from "@material-ui/core";
import { BeautifulDialog } from "./BaseDialog";

const DialogContentWrapper = styled(DialogContent)`
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
        font-family: "Source Sans Pro";
        width: 100%;
        height: 500px;
    }
`;

interface Props {
    token: string,
    fileExtensions: string[],
    handleSelectedFile?: Function,
    handleSelectedFiles?: Function,
    multiple?: boolean,
    closeDialog: Function
}

function BoxFilePicker({ token, fileExtensions, handleSelectedFile, handleSelectedFiles, multiple, closeDialog }: Props) {
    const ref = useRef();

    useEffect(() => {
        if (token) {
            // @ts-ignore
            const filePicker = new window.Box.FilePicker();

            filePicker.show("0", token, { // @ts-ignore
                container: ref.current,
                extensions: fileExtensions,
                ...(!multiple && { maxSelectable: 1 }),
            });

            filePicker.on("choose", files => {
                if (multiple && handleSelectedFiles) {
                    handleSelectedFiles(files);
                } else if (handleSelectedFiles) {
                    handleSelectedFiles(files.slice(0, 1));
                } else if (handleSelectedFile) {
                    handleSelectedFile(files[0]);
                }
                closeDialog();
            });
        }
    }, []);

    return (
        <div ref={ref} className="box-picker-container" />
    );
}

export default class BoxFilePickerDialog extends Component<Props> {
    render() {
        return (
            <BeautifulDialog closeButton closeDialog={this.props.closeDialog}>
                <DialogContentWrapper>
                    <BoxFilePicker {...this.props} />
                </DialogContentWrapper>
            </BeautifulDialog>
        );
    }
}
